import { buildArray } from '@anvil/common/util/array'
import { jsonToolResult } from '@anvil/common/util/messages'

import type { AnvilToolHandlerFunction } from '../handler-function-type'
import type {
  AnvilToolCall,
  AnvilToolOutput,
} from '@anvil/common/tools/list'
import type { Subgoal } from '@anvil/common/types/session-state'

export const handleAddSubgoal = (async (params: {
  previousToolCallFinished: Promise<void>
  toolCall: AnvilToolCall<'add_subgoal'>

  agentContext: Record<string, Subgoal>
}): Promise<{
  output: AnvilToolOutput<'add_subgoal'>
}> => {
  const { previousToolCallFinished, toolCall, agentContext } = params

  agentContext[toolCall.input.id] = {
    objective: toolCall.input.objective,
    status: toolCall.input.status,
    plan: toolCall.input.plan,
    logs: buildArray([toolCall.input.log]),
  }

  await previousToolCallFinished
  return { output: jsonToolResult({ message: 'Successfully added subgoal' }) }
}) satisfies AnvilToolHandlerFunction<'add_subgoal'>
